import { isSynced } from '../db/timestamps';

function formatRecordName(recordLabel) {
  if (recordLabel === 'record') {
    return 'Record';
  }

  return recordLabel.charAt(0).toUpperCase() + recordLabel.slice(1);
}

function revisionTimestamp(record) {
  if (record.updatedAt !== null && record.updatedAt !== undefined) {
    return record.updatedAt;
  }

  return record.lastSyncedAt ?? null;
}

export function revisionStatusText(record, formatDate, recordLabel = 'record') {
  const name = formatRecordName(recordLabel);
  const timestamp = revisionTimestamp(record);
  const syncStatus = isSynced(record) ? 'synced' : 'not yet synced';

  if (timestamp !== null && timestamp !== undefined) {
    return `${name} revision ${formatDate(timestamp)} · ${syncStatus}`;
  }

  return `${name} ${syncStatus}`;
}

export function revisionStatusInlineText(record) {
  if (isSynced(record)) {
    return 'Synced';
  }

  return 'Not yet synced';
}

export function revisionStatusTitle(
  record,
  formatDate,
  recordLabel = 'record'
) {
  const name = formatRecordName(recordLabel);
  const revisionDate = revisionTimestamp(record);

  if (isSynced(record)) {
    return `${name} revision from ${formatDate(
      revisionDate
    )} is synced with Harbours`;
  }

  if (record.lastSyncedAt === null || record.lastSyncedAt === undefined) {
    if (revisionDate !== null && revisionDate !== undefined) {
      return `${name} revision from ${formatDate(
        revisionDate
      )} is not yet synced with Harbours`;
    }

    return `${name} is not yet synced with Harbours`;
  }

  return `${name} revision from ${formatDate(
    revisionDate
  )} is not yet synced with Harbours. Previous revision synced with Harbours on ${formatDate(
    record.lastSyncedAt
  )}`;
}
